export const MouseButtons = {
    LeftButton: 0,
    MiddleButton: 1,
    RightButton: 2,
};

class MouseEventHandler {
    constructor() {
        this.width_ = 1;
        this.height_ = 1;

        this.mouseClicked_ = [false, false, false];
        this.mouseDoubleClicked_ = [false, false, false];
        this.mouseDown_ = [false, false, false];

        this.screenX_ = 0;
        this.screenY_ = 0;
        this.clientX_ = 0;
        this.clientY_ = 0;

        this.lastX_ = 0;
        this.lastY_ = 0;

        this.deltaMouseX_ = 0.0;
        this.deltaMouseY_ = 0.0;

        this.mouseInside_ = false;
    }

    getMouseDeltaX() {
        return this.deltaMouseX_;
    }
    getMouseDeltaY() {
        return this.deltaMouseY_;
    }

    isDown(mouseButton) {
        return this.mouseDown_[mouseButton];
    }

    isClicked(mouseButton) {
        return this.mouseClicked_[mouseButton];
    }

    isDoubleClicked(mouseButton) {
        return this.mouseDoubleClicked_[mouseButton];
    }

    isMouseInside() {
        return this.mouseInside_;
    }

    resetMouseState() {
        this.flush();
        this.screenX_ = 0;
        this.screenY_ = 0;
        this.clientX_ = 0;
        this.clientY_ = 0;
        this.lastX_ = 0;
        this.lastY_ = 0;
        this.deltaMouseX_ = 0.0;
        this.deltaMouseY_ = 0.0;

        this.wheelDelta_ = 0;

        this.normX_ = 0.0;
        this.normY_ = 0.0;

        for (let i = 0; i < 3; i++) {
            this.mouseDown_[i] = false;
        }
    }

    getNormX() {
        return this.normX_;
    }
    getNormY() {
        return this.normY_;
    }
    getMouseWheelDelta() {
        return this.wheelDelta_;
    }

    flush() {
        for (let i = 0; i < 3; i++) {
            this.mouseClicked_[i] = false;
            this.mouseDoubleClicked_[i] = false;
        }

        this.deltaMouseX_ = 0.0;
        this.deltaMouseY_ = 0.0;
        this.wheelDelta_ = 0;
    }

    onMouseMove(event) {
        this.screenX_ = event.screenX;
        this.screenY_ = event.screenY;
        this.clientX_ = event.offsetX;
        this.clientY_ = event.offsetY;

        let rect = event.target.getBoundingClientRect();
        this.width_ = rect.right - rect.left;
        this.height_ = rect.bottom - rect.top;

        if (this.mouseInside_) {
            this.deltaMouseX_ = (this.clientX_ - this.lastX_) / this.width_;
            this.deltaMouseY_ = (this.clientY_ - this.lastY_) / this.height_;
        }

        this.lastX_ = this.clientX_;
        this.lastY_ = this.clientY_;
        this.normX_ = this.clientX_ / (rect.right - rect.left);
        this.normY_ = 1.0 - this.clientY_ / (rect.bottom - rect.top);
        this.mouseInside_ = true;
    }

    onMouseDown(event) {
        this.mouseDown_[event.button] = true && this.mouseInside_;
    }

    onMouseUp(event) {
        this.mouseDown_[event.button] = false;
    }

    onMouseClick(event) {
        this.mouseClicked_[event.button] = true;
    }

    onMouseRightClick() {
        this.mouseClicked_[MouseButtons.RightButton] = true;
    }

    onMouseDoubleClick(event) {
        this.mouseDoubleClicked_[event.button] = true;
    }

    onMouseWheel(event) {
        this.wheelDelta_ = event.deltaY;
    }

    onMouseContextMenu(event) { }

    onMouseLeave(event) {
        this.mouseInside_ = false;
        this.resetMouseState();
    }
}

export { MouseEventHandler };
